export const LOAD_WALLETS_LIST = 'LOAD_WALLETS_LIST';
export const CREATE_WALLET = 'CREATE_WALLET';
export const RESET_WALLETS = 'RESET_WALLETS';
export const LOAD_BALANCES = 'LOAD_BALANCES';
export const EDIT_WALLET_DESCRIPTION = 'EDIT_WALLET_DESCRIPTION';
export const DELETE_WALLET = 'DELETE_WALLET';
export const LOAD_AML_REPORTS = 'LOAD_AML_REPORTS';
export const REFRESH_WALLET = 'REFRESH_WALLET';
export const CHECK_WALLET_AML = 'CHECK_WALLET_AML';
